import React, { Component } from 'react';

class Configuracoes extends Component {
  render() {
    return <div>Configuracoes Página</div>;
  }
}

export default Configuracoes;
